import customFetch from "services/api";

export const logoutAdmin = () =>
  customFetch("dashboard/admins/logout", { method: "POST" });
